
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/list",
      function () {
        return require("private-next-pages/jobs/list.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs/list"])
      });
    }
  